<fieldset id=concurrentBox data-help="concurrent" class="activityarea activity"
          style="border: 3px solid {concColor}" style:filter={(order.valid) ? "brightness(150%)" : null} >
	<h3 onclick={() => show_actionCard(concurrent?.action ?? order.action, 'map')}>Nebenbei:</h3>
	<div class="activityarea-inner">
		<div class=actdata>
					<!-- 1st line: current action selector and aim input -->
					<ActionSelect currency=side action={concurrent?.action ?? order?.action} onchange={check_validity} />
					<input id=aim type=text class="text lockable" placeholder="Ziel" value={concurrent?.aim?.str ?? concurrent?.aim ?? order?.aim} list=fighterList onchange={check_validity}/>
					<!-- 2nd line: MASTER ONLY info on proficiency, defense, chance and difficulty -->
					{#if user.isMaster}
							<p class=centered>{concurrent?.dur} s</p>
							<div id=evaluation class="doublespan">
									<Input field=pro help="evaluation" value={evaluation.pro} type=number disabled/>
									<span>{(evaluation.mod < 0) ? "–" : "+"}</span>
									<Input field=mod help="evaluation" value={Math.abs(evaluation.mod)} type=number disabled/>
									<span>{(evaluation.con > 0) ? "–" : "+"}</span>
									<Input field=con help="evaluation" value={Math.abs(evaluation.con)} type=number disabled/>
									<span>{(evaluation.dfc < 0) ? "+" : "–"}</span>
									<Input field=bon value={Math.abs(evaluation.bon)} type=number onchange={change_concurrent}/>
									<span> > </span>
							</div>
							<Input field=chance help="evaluation" value={100 - evaluation.chance} type=number disabled/>
					{/if}
					<!-- 3rd line: info on rolled and resulting success tier, D100 roll button -->
					<div class=doublespan>
							{#if user.isMaster}
									<input id=rolled type=text class="text doublespan" placeholder="Wurf" value={concurrent?.rolled}
												 onclick={(e) => e.target.select()} onchange={change_concurrent} >
							{:else}
									<p id=conc_rolled class="doublespan">{(concurrent) ? `${concurrent.rolled} – ${concurrent.state}` : order.descript}</p>
							{/if}
							{#if hasSecondChance}
								<button type=button class="button miniButton" onclick={() => second_roll} disabled>
										<img class="buttonImage" src="/static/buttons/D100.png" alt="W100">
								</button>
							{/if}
					</div>
					{#if user.isMaster}
							<input id=success data-help="successtier" type=number class="text centered" placeholder={concurrent?.success ?? "succ"} value={concurrent?.revision}
										 onchange={change_concurrent}/>
					{/if}
		</div>
		{#if user.isMaster && false}
					<button class="button review" onclick={start_concurrent}>
							<img src="/static/buttons/accept.png" alt="Ja" class="commentImg">
							akzeptieren
					</button>
					<button class="button review" onclick={start_concurrent}>
							<img src="/static/buttons/reject.png" alt="Nein" class="commentImg">
							verwerfen
					</button>
		{:else if !concurrent && order.valid}
					<button class="button react" onclick={start_concurrent}>ANFRAGEN</button>
		{/if}
	</div>
</fieldset>

<datalist id="fighterList"></datalist>


<script>
    import { user, game, send_request} from "../client.svelte.js";
    import {noActivity, notEmpty, calc_activityColor} from "../core.js";
    import ActionSelect from "./ActionSelect.svelte";
    import {show_actionCard} from "../dialogs/OptionDialog.svelte"
    import Input from "../elements/Input.svelte";

	// component state variables
    let concurrent = $derived(game.activities.get(view.persona.concurrent) ?? null)
    let evaluation = $derived(concurrent?.evaluation ?? {pro: 0, con: 0, mod: 0, bon: 0, chance: 0})
    let hasSecondChance = $derived(concurrent?.amends?.find(eff => eff.type === 'Advantage') ?? false)
    let concColor = $derived((concurrent) ? calc_activityColor(concurrent.action) :
                             (order.valid) ? calc_activityColor(order.action) : 'unset')
    let order = $state({})

    /// if persona.reacting is changed then replace order with persona.reacting
    $effect(() => {
        if (view.persona?.reacting) order = view.persona.reacting
    })


    function check_validity(e) {
        e.stopPropagation()
        order[e.target.id] = e.target.value
        // check if action/aim is valid, get duration and change state of submit button
        send_request('preview', $state.snapshot(order), "Check validity", (response) => order = Object.assign(order, response))
	}

    function change_concurrent({target: {id, value}}) {
        if (!(concurrent.ID && user.isMaster))  return
        const attrib = (typeof this === 'string') ? this : id
        const newval = (['bon', 'rolled'].includes(attrib)) ? Number(value) : value
        send_request('alter', {action: 'UPDATE', actID: concurrent.ID, attrib: attrib, value: newval}, "Master changes concurrent attribute")
	}

    function start_concurrent() {
        game.place_order(order)
        order = {}
	}


    function second_roll(inflID) {
        send_request('alter', {action: 'ROLL', actID: concurrent.ID, attrib: 'ROLL', value: inflID}, `Use Second Chance for ${inflID}`)
	}

</script>


<style lang="sass">
	//.activity
	//	color: lightgray

	//.activityarea
	//	position: relative
	//	border-radius: 10px
	//	border: 2px solid black
	//	box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
	//	margin: 6px
	//	break-inside: avoid

	button.review
		width: 40%
		margin: 0 16px

	button.react
		background-color: grey
		width: calc(100% - 16px)
		height: 32px
		margin: 8px

	img
		width: 100%

	#evaluation
		display: grid
		grid-template-columns: repeat(4, 3ch 1ch)
		justify-content: space-around
		justify-items: center

	#evaluation span
		align-self: center

	#conc_rolled
		display: inline-block
		width: calc(100% - 48px)

</style>